// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"g3-z","trustedRetailerTooltipWrapper":"h3-z"};